export default __webpack_public_path__ + "static/media/about_icon2.2dd6124b.svg";